<div class="gamificationDetailPage toolPopupContainer modal-dialog modal-xl modal-dialog-centered"
    style="z-index:10000;">
    <div class="modal-content">
        <div class="GDPBorder" (click)="currentPage='main'; currentPageChange.emit('main');"></div>
        <div class="GDPWindow border_shadow" style="height: 80%;" id="GDPMainWindow">
            <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail close_right cursor-pointer" style="margin: 0px;"
                (click)="close()">
                <use href="../../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
            </svg>
            <div class="row d-flex justify-content-between">
                <div class="col-4">
                    <div class="lato-regular color-no2Pencil font-size-18">{{title}}</div>
                </div>
                <div class="col-4" style="position: absolute; right:80px;">
                    <div class="search-box live-search">
                        <input type="search" class="form-control" name="CustomFilter" [(ngModel)]="listFilter"
                            placeholder="Search" autocomplete="off" (change)="updateGridFilter()" cvLocalizedPlaceholder
                            langSection="Common" langKey="Search" />
                        <span class="clear-input" [hidden]="listFilter.length == 0" (click)="clearSearch()"></span>
                    </div>
                </div>
            </div>
            <!-- coin, gem and badge module -->
            <div class="GDPContent">
                <div class="game_detail_black_box"
                    *ngIf="currentPage == 'coin' || currentPage == 'gem' || currentPage == 'badge'">
                    <div *ngIf="currentPage == 'coin'" class="game_detail_tab">
                        <div class="section_tab_coin game_detail_detail_box">
                            <div class="coin_gem_left_title">
                                <span class="game_detail_tab_label" cvLocalizedText langSection="Users"
                                    langKey="All_Coins">All coins</span>
                            </div>
                            <div class="coin_gem_center_icon">
                                <img src="../App_Themes/Standard/Images/Admin/CoinIcon.svg" title="Coin"
                                    style="height: 65%;">
                            </div>
                            <div class="coin_gem_right_value">
                                <div style="font-size: 20px; align-self: center;">{{userProfile.AvailableSpendingPoints
                                    | number : '1.0-0'}}</div>
                                <div class="game_black_small_label_coin"
                                    style="font-size: 12px; align-self: center; margin-top:5%; margin-left:6px;">coins
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPage == 'gem'" class="game_detail_tab">
                        <div class="section_tab_gem game_detail_detail_box">
                            <div class="coin_gem_left_title">
                                <span class="game_detail_tab_label" cvLocalizedText langSection="Users"
                                    langKey="All_Gems">All gems</span>
                            </div>
                            <div class="coin_gem_center_icon">
                                <img src="../App_Themes/Standard/Images/Admin/GemIcon.svg" title="Gem"
                                    style="height:50%;">
                            </div>
                            <div class="coin_gem_right_value">
                                <div style="font-size: 20px; align-self: center;">{{userProfile.AvailableGems | number :
                                    '1.0-0'}}</div>
                                <div class="game_black_small_label_gem"
                                    style="font-size: 12px; align-self: center; margin-top:5%; margin-left:6px;"
                                    cvLocalizedText langSection="Users" langKey="Gems">gems</div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="currentPage == 'badge'" class="game_detail_tab">
                        <div class="section_tab_badge game_detail_detail_box"
                            style="width:50% !important; padding: 1%; padding-left: 2%; justify-content: space-around;">
                            <div style="height: 100%; width: 35%; margin-top: 0.5%;">
                                <img src="../App_Themes/Standard/Images/Admin/AwardIcon1.svg" title="Badge"
                                    style="height: 90%;">
                            </div>
                            <div style="height: 100%; width: 35%; display: inline-flex;">
                                <div style="font-size: 20px; align-self: center;">
                                    {{badgeNum | number : '1.0-0'}}
                                </div>
                                <div class="game_black_small_label_badge"
                                    style="font-size: 12px; align-self: center; margin-top:5%; margin-left:6px;"
                                    cvLocalizedText langSection="Users" langKey="Badges">badges</div>
                            </div>
                        </div>
                    </div>
                    <div class="section_tab_coin game_detail_add_subtract cursor-pointer mr-n5r"
                        *ngIf="currentPage == 'coin' && (permissions?.WriteAccess || permissions?.CreateAccess)"
                        (click)="addNewCoin()">
                        <span class="add_subtract_span" cvLocalizedText langSection="Users"
                            langKey="Add_Subtract_Coins">Add/Subtract coins</span>
                    </div>-->
                    <!-- <div class="section_tab_gem game_detail_add_subtract" *ngIf="currentPage == 'gem'" (click)="isEditingGem = true">
                        <span class="add_subtract_span"
                        cvLocalizedText langSection="Users" langKey="Add_Subtract_Gems">Add/Subtract gems</span>
                    </div> -->
                    <!-- <div class="section_tab_badge game_detail_add_subtract" style="width:20%;" *ngIf="currentPage == 'badge'"
                        (click)="isEditingBadge = true">
                        <span class="add_subtract_span"
                        cvLocalizedText langSection="Users" langKey="Award_Badge">Award badge</span>
                    </div> -->
                </div>
                <!-- table -->
                <div class="pt-3 pr-3 gamification-page-grid" *ngIf="dataLoading">
                    <ag-grid-angular #gamificationDetailPageGrid class="h-100 flex-grow-1 ag-theme-balham ag-basic"
                        [gridOptions]="gridOptions"></ag-grid-angular>
                </div>
            </div>
        </div>
        <div id="GDPBorder" class="GDPBorder" (click)="currentPage='main'; currentPageChange.emit('main');"></div>
    </div>
</div>